'use client';

/**
 * Login Form Wrapper with Redirect Support
 * 
 * Client component that reads the redirect query parameter and passes it to LoginForm.
 */

import { useSearchParams, usePathname } from 'next/navigation';
import { LoginForm } from '@/components/auth/LoginForm';
import { useTenantOptional } from '@/contexts/TenantContext';

export function LoginFormWithRedirect() {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const redirect = searchParams.get('redirect');
  const tenant = useTenantOptional();
  
  // Extract locale from current pathname (e.g., /en/login -> en)
  const localeMatch = pathname.match(/^\/([a-z]{2})(\/|$)/);
  const locale = localeMatch ? localeMatch[1] : (tenant?.locale || 'en');
  
  // Use the redirect param if provided, otherwise default to /{locale}/account
  // Ensure the redirect path includes the locale prefix for proper routing
  const redirectTo = redirect || `/${locale}/account`;
  
  return (
    <LoginForm
      redirectTo={redirectTo}
      showRegisterLink={true}
      registerUrl={redirect ? `/${locale}/register?redirect=${encodeURIComponent(redirect)}` : `/${locale}/register`}
      showForgotPasswordLink={true}
      forgotPasswordUrl={`/${locale}/forgot-password`}
      showSocialAuth={true}
    />
  );
}
